module.exports = __webpack_public_path__ + "img/mickey56.065f6ea6.jpg";